// Copyright (C) 2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';

interface Props {
    data: JobReportData[];
}

type NullableNumber = number | null | undefined;
type NullableString = string | null | undefined;

interface JobReportData {
    annotatingTime: number;
    drawCount: NullableNumber;
    deleteCount: NullableNumber;
    updateCount: NullableNumber;
    assigneeId: NullableNumber;
    assigneeName: NullableString;
    frameCount: number;
    issuesCount: number;
    jobId: number;
    organizationId: NullableNumber;
    organizationName: NullableString;
    projectId: NullableNumber;
    projectName: NullableString;
    score: number;
    taskId: number;
    taskName: string;
}

function JobReportTable(props: Props): JSX.Element | null {
    const { data } = props;

    return (
        <table>
            <thead>
                <tr>
                    <th>作业ID</th>
                    <th>任务ID</th>
                    <th>任务名称</th>
                    <th>项目ID</th>
                    <th>项目名称</th>
                    <th>组织ID</th>
                    <th>组织名称</th>
                    <th>受托人ID</th>
                    <th>受托人名称</th>
                    <th>帧数量</th>
                    <th>创建标注数量</th>
                    <th>删除标注数量</th>
                    <th>更新标注数量</th>
                    <th>问题数量</th>
                    <th>标注合格率</th>
                    <th>标注时间（小时）</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => (
                    <tr key={index}>
                        <td>{item.jobId}</td>
                        <td>{item.taskId}</td>
                        <td>{item.taskName}</td>
                        <td>{item.projectId}</td>
                        <td>{item.projectName}</td>
                        <td>{item.organizationId}</td>
                        <td>{item.organizationName}</td>
                        <td>{item.assigneeId}</td>
                        <td>{item.assigneeName}</td>
                        <td>{item.frameCount}</td>
                        <td>{item.drawCount}</td>
                        <td>{item.deleteCount}</td>
                        <td>{item.updateCount}</td>
                        <td>{item.issuesCount}</td>
                        <td>{item.score}</td>
                        <td>{item.annotatingTime}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default React.memo(JobReportTable);
